import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import BtnSelect from '../../../Shared/Buttons/BtnSelect';
import BtnPink from '../../../Shared/Buttons/BtnPink';
import {isMobile} from 'react-device-detect';

export default function BottomButtons({
                                        onClickNavigation,
                                        canContinue,
                                        continueText
                                      }) {
  const handleClickContinue = () => {
    onClickNavigation();
  };

  const handleClickBack = () => {
    window.history.back();
  };

  return (
    <Container fluid className="idf-sale-buttons-container">
      <BtnPink
        text={continueText ? continueText : 'המשך'}
        disabled={canContinue ? false : true}
        onclick={handleClickContinue}
      />
      {!isMobile && <BtnSelect text={'חזרה למסך הקודם'} onClick={handleClickBack} />}
    </Container>
  );
}
